routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.category', {
      url: "categories",
      template: `<category sh-ctrl="shCtrl"></category>`
    })
    .state('home.categorySlug', {
      url: "categories/{categorySlug}",
      template: `<category sh-ctrl="shCtrl"></category>`
    })
    .state('home.categoryId', {
      url: "categories/{idCategory}",
      template: `<category sh-ctrl="shCtrl"></category>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/category/category.config.js
 **/